import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Track from '@project/shared/utils/tracking/js/tracking';

const classes = {
	isCarousel: 'm-hero-article-stage--is-carousel',
	largeItem: 'js-m-hero-article--large-item',
	smallItem: 'js-m-hero-article--small-item',
	mainWrapper: 'js-m-hero-article-stage__main',
	itemActive: 'state-m-hero-article--item-is-active',
};

@createModule('HeroArticleStage')
/**
 * HeroArticleStage
 */
export class HeroArticleStage extends TerrificSpec {
	$ctx: JQuery;
	$largeItem: JQuery;
	$smallItem: JQuery;
	$mainWrapper: JQuery;
	$itemActive: JQuery;
	activeIndex: number;
	sliderlength: number;
	verticalWrapperHeight: number;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$largeItem = $(`.${classes.largeItem}`, this.$ctx);
		this.$smallItem = $(`.${classes.smallItem}`, this.$ctx);
		this.$mainWrapper = $(`.${classes.mainWrapper}`, this.$ctx);
		this.$itemActive = $(`.${classes.itemActive}`, this.$ctx);
		this.activeIndex = 0;
		this.sliderlength = this.$smallItem.length;
		this.verticalWrapperHeight = 215 * 3;

		if(this.$ctx.hasClass(classes.isCarousel)) {
			this.initScroller();
		};

		this.RegisteredUpdate();

		resolve();
	}

	stop() { }

	setActiveItem(pageNumber: number) {
		this.$largeItem
			.removeClass(classes.itemActive)
			.eq(pageNumber)
			.addClass(classes.itemActive);

		this.$smallItem
			.removeClass(classes.itemActive)
			.eq(pageNumber)
			.addClass(classes.itemActive);

		this.$smallItem
			.removeAttr('style')
			.eq(pageNumber)
			.animate({
				height: 'hide'
			});
	}

	setWrapperHeight(pageNumber: number) {
		var verticalActiveHeight = this.verticalWrapperHeight;
		var mainWrapperHeight = this.$largeItem.eq(pageNumber).height();
		if (mainWrapperHeight > verticalActiveHeight) {
			this.$ctx.height(mainWrapperHeight);
		} else {
			this.$ctx.height(verticalActiveHeight);
		}
	}

	goToItemX(pageNumber: number) {
		var me = this;
		me.setActiveItem(pageNumber);
		// setTimeout(() => {
		// 	me.setWrapperHeight(pageNumber);
		// }, 500);

		var interval = setInterval(function () {
			pageNumber++;
			if (pageNumber > me.sliderlength - 1) {
				pageNumber = 0;
			}
			me.setActiveItem(pageNumber);
			//me.setWrapperHeight(pageNumber);
		}, 4000);

		this.$ctx.mouseenter(function () {
			clearInterval(interval);
		});

		this.$ctx.mouseleave(function () {
			interval = setInterval(function () {
				pageNumber++;
				if (pageNumber > me.sliderlength - 1) {
					pageNumber = 0;
				}
				me.setActiveItem(pageNumber);
				//me.setWrapperHeight(pageNumber);
			}, 4000);
		});
	}

	initScroller() {
		this.goToItemX(this.activeIndex);
	}

	RegisteredUpdate() {
		if(Track.isKnownMarketoLead()) {
			this.$ctx.find('.m-hero-article-stage--gated').removeClass('m-hero-article-stage--locked');
		}
		if(Track.isKnownCdcLead()) {
			this.$ctx.find('.m-hero-article-stage--gated').removeClass('m-hero-article-stage--locked');
		}
	}
}
